// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"461":"awards","501":"apple","516":"team","619":"live-demo","818":"client","912":"contacts","946":"news"}[chunkId] + "." + {"461":"a3ff7d09","501":"55a2f301","516":"a4db1b0f","619":"6a7f425b","818":"38079837","912":"8fdf27f0","946":"811514ba"}[chunkId] + ".js";
};